<template>
  <div class="parking_box">
      <section>
        <div class="package_top">
            <div class="package_top_left">
                <span class="package_top_span">优惠类型</span>
            </div>
            <div class="package_top_right" @click="toallList()" v-if="allPrkParkFeeBeanList.length>3">
                <span class="package_top_span1">更多</span>
                <img class="package_top_icon" src="../../assets/images/icon_indicator_next.png" />
            </div>
        </div>
        <section class="package_box">
        <!-- newParkingMess -->
        <section
            :class="['package_item',ParkFeeId==item.id?'cur':'', lprkParkFeeBeanList.length == 1?'package_item_one':'']"
            v-for="item in lprkParkFeeBeanList"
            :key="item.id"
            @click="select(item)"
        >
            <!-- 是租户且有租户折扣显示折扣图标 -->
            <img
            v-if="isUser && item.enableCompanyDiscount == 1"
            class="discount"
            src="../../assets/images/discount.png"
            />
            <div class="h3div">
            <span class="h3Span" v-if="item.parkTypeName">{{item.parkTypeName}}</span>
            <span class="h3Span" v-else>{{item.dayNightType|parkTypeName}}</span>
            </div>
            <p v-if="item.dayNightType == 1" class="time_range">24小时</p>
            <p
            v-else-if="item.dayNightType == 2"
            class="time_range"
            >{{parkingMess.dayStartHour}}-{{parkingMess.dayEndHour}}</p>
            <p v-else class="time_range">
            {{parkingMess.nightStartHour}}-{{parkingMess.nightEndHour}}
            <span>+1</span>
            </p>
            <section class="price_box" v-if="!isUser || item.enableCompanyDiscount != 1">
            <p>{{item.feeStandard}}</p>
            <span>元/月</span>
            </section>
            <template v-else>
            <section class="price_box">
                <p>{{item.companyDiscount.toFixed(2)}}</p>
                <span>元/月</span>
            </section>
            <p class="underline_text">{{item.feeStandard}}元</p>
            </template>
            <img
            v-if="item.dayNightType == 1"
            class="icon_t"
            src="../../assets/images/parking/icon_all_day.png"
            />
            <img
            v-else-if="item.dayNightType == 2"
            class="icon_t"
            src="../../assets/images/parking/icon_daytime.png"
            />
            <img v-else class="icon_t" src="../../assets/images/parking/icon_night.png" />
            <img
            v-if="dayNightType == item.dayNightType"
            class="icon_select"
            src="../../assets/images/selected.png"
            />
        </section>
        </section>
        <!-- <img
        v-if="!isUser && hasDiscount"
        class="identity"
        @click="toCompany"
        src="../../assets/images/ident.jpg"
        alt
        /> -->
      </section>
      <section class="apply_mess">
     <!-- v-if="showApplyInput" -->
        <h3>填写申请信息</h3>
        <section v-for="(item,index) in prkParkLotBeanList" :key="index"> 
            <section class="mess_list">
                <section class="mess_list_item">
                    <p class="list_item_left">
                        申请人
                        <span>*</span>
                    </p>
                    <input
                        class="list_item_right"
                        type="text"
                        v-model.trim="item.userName"
                        @input="nameInputFun(index)"
                        placeholder="请输入真实姓名"
                    />
                </section>
                <!--   -->
                 <img
                        @click.stop="deleteCard(index)"
                        class="delect_icon"
                        v-if="prkParkLotBeanList.length > 1 && come != 'xuqian'"
                        src="../../assets/images/delete_red.png"
                    />
                <section class="mess_list_item">
                    <p class="list_item_left">
                        联系电话
                        <span>*</span>
                    </p>
                    <input
                        class="list_item_right"
                        type="number"
                        :maxlength="11"
                        v-model.trim="item.phone"
                        @input="nameInputFun(index)"
                        placeholder="请输入联系电话"
                    />
                </section>
                <section class="mess_list_item">
                    <p class="list_item_left">
                        生效开始
                        <span>*</span>
                    </p>
                    <p
                        @click="selectTime(1,index)"
                        :class="['list_item_right','list_item_right_p',item.applyStartDay?'':'placeholder']"
                    >{{item.applyStartDay?item.applyStartDay:'请选择开始日期'}}</p>
                    <img src="../../assets/images/icon_indicator_next.png" />
                </section>
                <section class="mess_list_item">
                    <p class="list_item_left">
                        生效结束
                        <span>*</span>
                    </p>
                    <p
                        @click="selectTime(2,index)"
                        :class="['list_item_right','list_item_right_p',item.applyEndDay?'':'placeholder']"
                    >{{item.applyEndDay?item.applyEndDay:'请选择结束日期'}}</p>
                    <img src="../../assets/images/icon_indicator_next.png" />
                    </section>
            </section>
            <section class="card_main">
                <section class="card_box" v-for="(cardItem,cardIndex) in item.cardList" :key="cardItem+cardIndex">
                    <img
                        @click.stop="delectCardItem(cardIndex,index)"
                        class="delect_icon"
                        v-if="item.cardList.length > 1 && come != 'xuqian'"
                        src="../../assets/images/delete_red.png"
                    />
                    <section class="mess_list">
                        <section class="mess_list_item">
                        <p class="list_item_left">
                            车牌号
                            <span>*</span>
                        </p>
                        <p
                            :class="['list_item_right_card',!cardItem.cardNumber?'placeholder':'',come == 'xuqian'?'notclick':'']"
                            @click="showKeyBoard(cardIndex,index)"
                        >{{!cardItem.cardNumber?'请输入车牌号':cardItem.cardNumber}}</p>
                        <!-- <input class="list_item_right" type="text" v-model="cardNumber" placeholder="请输入车牌号"> -->
                        </section>
                    </section>
               
                    <h4 v-if="showUpLoadImg" style="background-color: #fff;">
                        上传照片
                        <span v-if="mustImg != 2">*</span>
                    </h4>
                <!-- {{mustImg != 2?"请务必上传真实有效的驾驶证正副页、行驶证正副页、驾驶员身份证正反面、爱车照片、公司证明等证明材料。":"上传真实有效的驾驶证正副页、行驶证正副页、驾驶员身份证正反面、爱车照片、公司证明等证明材料，可提高申请通过成功率哦~"}} -->
                <div
                    v-if="showUpLoadImg"
                    class="tips"
                >
                <span>1、首次申请时，请上传驾驶证、车辆照片、身份证(或园区工作证明)等信息；</span>
                <span> 2、续保申请时，只需上传身份证(或园区工作证明)即可；</span>
                </div>
                <div class="pic">
                    <div class="addPic" v-for="(imgItem,imgIndex) in cardItem.fileList" :key="imgItem.path">
                    <img class="video" :src="imgItem.path" @click="viewImage(imgItem,cardIndex,imgIndex)" />
                    <img
                        class="deleteFile"
                        v-if="come != 'xuqian'"
                        @click.stop="deleteFile(imgItem,cardIndex,imgIndex,index)"
                        src="../../assets/images/btn_clear.png"
                    />
                    </div>
                    <div class="addPic" v-if="come != 'xuqian' && cardItem.fileList.length<9">
                    <img class="addImg" src="../../assets/images/repair/add.png" />
                    <div class="item_center_inp" style="opacity:0;">
                        <uploadimg-spaceup
                        :multiple="true"
                        :targetId="cardItem.targetId"
                        :fileList="cardItem.fileList"
                        moduleCode="TCP"
                        @uploadImgEnd="uploadImgEnd"
                        :index="index*10000+cardIndex"
                        ></uploadimg-spaceup>
                    </div>
                    </div>
                </div>
                
                </section>
                <!-- &&serverType!=2 && parkingMess.id != 8 && parkingMess.id != 9 -->
                <section
                    class="add_card" v-if="come != 'add' && item.cardList.length < 3 && come != 'xuqian' ">
                    <section class="add_card_main" @click="addCardNumber(index)">
                        <!-- <img :src="require(`../../assets/images/btn_add_${$store.state.common.theme}.png`)" /> -->
                        <span>添加车牌</span>
                    </section>
                </section>
            </section>    
        
        </section>
        <div class="add_card chewei">
            <section class="add_card_main" @click="addCard()">
                <span>添加车位</span>
            </section>
        </div>
    <!-- <template v-else>
      <section class="end_time">
        <img src="../../assets/images/warning.jpg" />
        <p>该月卡优惠将于{{maxEndDay|formatTime(181)}}结束</p>
      </section>
    </template> -->
     <yd-datetime
            style="display:none;"
            ref="datetime_date"
            @input="dateChange"
            type="date"
            v-model="date"
            :startDate="curDate"
            :endDate="maxDate"
    ></yd-datetime>
    <yd-datetime
            style="display:none;"
            ref="datetime_month"
            @input="dateChange"
            type="month"
            v-model="date_m"
            :startDate="curDate"
            :endDate="maxDate"
        ></yd-datetime>
      </section>
       <!--   《停车月保申请须知内容》-->
      <div class="agreeView" v-if="isShowAgreeActon">
          <div @click.stop="changeAgree" v-if="!isAgree" class="agreeView_div"></div>
          <img  @click.stop="changeAgree" v-else class="agreeView_icon" src="../../assets/images/icon_check_0.png" />
          <span @click="showAgreePopup" class="agreeView_span1">请查阅并同意</span>
          <span @click="showAgreePopup"  class="agreeView_span2">{{"《"+parkingMess.noticeTitle+"》"}}</span>
      </div>
      <div v-if="isShowAgreeActon" class="bottom_box"></div>
      <div class="bottom_box"></div>

       <common-footer
        text="立即申请"
        :canClick="buttoncanClick"
        @btnClick="btnClick"
      ></common-footer>

       <mt-popup v-model="showPopup" position="bottom" class="mint-popup">
            <key-board v-if="showPopup"
                @sure="sureCardNumber"
                :cardIndex="passIndex"
                :cardNumber="cardNumber"
                @close="showPopup = false"
            ></key-board>
        </mt-popup>
        <mt-popup v-model="isshowPopup" class="mint-popup">
            <div class="popupview">
                <span class="popupview-span1">{{parkingMess.noticeTitle}}</span>
                <textarea readonly class="popupview-span2" v-model="parkingMess.noticeContent"></textarea>
                <!-- <span class="popupview-span2" v->dsdsd  \n  sdsdsd</span> -->
                <span @click="hidePopup" class="popupview-span3">知道了</span>
            </div>
        </mt-popup>
  </div>
</template>
<script>
import util from '../../utils/util';
import { approvalMixin } from '../../utils/approvalMixin';
import storage from '../../utils/storage';
import uploadimgSpaceup from '../../components/uploadImgSpaceup';
import CommonFooter from '../../components/footer';
// import KeyBoard from '../../components/keyBoard';
import KeyBoard from '../parking/components/keyBoard';
import { loadParkHeaderById, spaceUpPcHttp } from '../../utils/api';
import { mapState } from 'vuex';
export default {
  name: 'parkingCompanyPass',
  props: {},
  mixins: [approvalMixin],
  components: {
    CommonFooter,
    uploadimgSpaceup,
    KeyBoard
  },
   data() {
        return {
            showPopup:false,
            canClick:true,
            isAgree :false,
            isshowPopup:false,
            come:"",
            companyName:'',
            parkingMess:{},
            allPrkParkFeeBeanList:[],
            lprkParkFeeBeanList :[],
            isUser: false,
            hasDiscount: false,
            parkList:[],
            dataList:[],
            parkSelect:false,
            parkId:'',
            isShowAgree:true,
            mustImg:'',
            dayNightType:'',
            maxEndDay:'',
            ParkFeeId:'',
            feeTypeName :'',
            vipTypeCode : '',
            vipTypeName:'',
            ParkFeeSelectItem:'',

            timemap:'',
            hex_md5_return: '',
            removeSomeUrl: spaceUpPcHttp + '/syscfg/attachmentTerminal/removeSomeAttachment',
            searchFileUrl: spaceUpPcHttp + '/syscfg/attachmentTerminal/queryAttachmentListByOneData',
            changeTargetIdUrl: spaceUpPcHttp + '/syscfg/attachmentTerminal/bindSomeAttachmentsList',
            queryBpmFlowByBuildIds: spaceUpPcHttp + '/syscfg/bpmSyscfg/queryBpmFlowByBuildIds',
            prkParkLotBeanList:[{
                platform:"RST",
                userId:"",
                
                companyName:"",
                companyId:"",
                subProjectId:"2",
                
                numberType:2,
                parkHeaderId:'',
                plateNo:"",
                cardList:[{
                     fileList: [],
                     targetId: new Date().getTime(),
                     cardNumber: ''
                }],
                phone:"",
                userName:"",
                applyStartDay:"",
                applyEndDay:"",
                dayNightType:''
            }],
            timeIndex:'',
            cardNumber:'',
            passIndex:0,
            selectPass:'', 
            selectCardIndex: '',//判断是点击哪个车牌
            userS:false,
            date: '2020-01-01',
            date_m:'2050-01-01',
            showUpLoadImg:true,

            
        }
    },
    computed: {
        ...mapState({
            common: state => state.common
        }),
        curDate() {
            // 来自续签
            if (this.come == 'xuqian') {
                if (Object.keys(this.applyData).length <= 0) {
                    return util.formatTime(new Date(), 19)
                }
                // 年月日格式
                let newD = this.applyData.prkParkApplyLogBeans.filter(item => {
                    return item.applyStatus == 2 || item.applyStatus == 4
                })
                console.log(newD)
                let endDay = newD[0].applyEndDay;
                // 如果结束时间小于当前时间,取当前时间作为开始时间
                if (new Date(endDay.replace(/\./g, '/')).getTime() - new Date().getTime() < 0) {
                    endDay = util.formatTime(new Date(), 9)
                }
                if (this.parkingMess.monthType == 2) {
                this.date = util.formatTime(new Date(new Date(endDay.replace(/\./g, '/')).getTime() + 1 * 1000), 4)
                return util.formatTime(new Date(new Date(endDay.replace(/\./g, '/')).getTime() + 1 * 1000), 19)
                } else {//年月格式
                let newD = new Date(endDay.replace(/\./g, '/'));
                newD = new Date(newD.valueOf() + 1 * 60 * 60 * 1000);
                console.log(util.formatTime(newD, 19))
                return util.formatTime(newD, 19)
                }
            } else {
                return util.formatTime(new Date(), 20)
             }
      
        },
        maxDate() {
            if (Object.keys(this.parkingMess).length > 0) {
                let year, month, day;
                if (this.come == 'xuqian') {
                    if (Object.keys(this.applyData).length <= 0) {
                        console.log("maxday1 === " + JSON.stringify(util.formatTime(new Date(), 20)) )
                        return util.formatTime(new Date(), 20)
                    }
                    let newD = this.applyData.prkParkApplyLogBeans.filter(item => {
                        return item.applyStatus == 2 || item.applyStatus == 4
                    })
                    let endDay = newD[0].applyEndDay;
                    // 如果结束时间小于当前时间,取当前时间作为开始时间
                    if (new Date(endDay.replace(/\./g, '/')).getTime() - new Date().getTime() < 0) {
                        endDay = util.formatTime(new Date(), 9)
                    }
                    year = util.formatTime(new Date(endDay.replace(/\./g, '/')), 17).year
                    month = util.formatTime(new Date(endDay.replace(/\./g, '/')), 17).month
                    day = util.formatTime(new Date(endDay.replace(/\./g, '/')), 17).day
                } else {
                    year = util.formatTime(new Date(), 17).year
                    month = util.formatTime(new Date(), 17).month
                    day = util.formatTime(new Date(), 17).day
                }
                // 非整月模式且最大起租单位是日
                console.log("parkingMess.monthType === " + this.parkingMess.monthType + "  " + this.parkingMess.applyMaxUnit +'.  ' + this.parkingMess.applyMaxCount)
                if (this.parkingMess.monthType == 2 && this.parkingMess.applyMaxUnit == 1) {
                    let time = new Date(year + '/' + month + '/' + day + ' 00:00:00').getTime() + (this.parkingMess.applyMaxCount - 1) * 24 * 60 * 60 * 1000;
                    // 判断最大时间是否大于价格期间的最大日期
                    if (time > this.maxEndDay) {
                        time = this.maxEndDay
                    }
                    let d = util.formatTime(new Date(time), 20)
                    console.log("maxday4 === " + JSON.stringify(d) )
                    return d
                } else {
                    let ys = parseInt((month - 0 + this.parkingMess.applyMaxCount - 1) / 12);
                    year = year + ys;
                    console.log("this.parkingMess.applyMaxCount === " + this.parkingMess.applyMaxCount)
                    let m = month - 1 + this.parkingMess.applyMaxCount - ys * 12;
                    month = m >= 10 ? m : '0' + m
                    console.log(year, month, day)
                    let newSjc = new Date(year + '/' + month + '/' + day + ' 00:00:00').getTime();
                     console.log("newSjc  ===  " + JSON.stringify(util.formatTime(new Date(newSjc), 20)))
                    console.log("this.maxEndDay  ===  " + JSON.stringify(util.formatTime(new Date(this.maxEndDay), 20)))
                    if (this.come != 'xuqian' && this.parkingMess.monthType == 2) {
                        newSjc = newSjc - 24 * 60 * 60 * 1000;
                    }
                    if (newSjc > this.maxEndDay) {
                        newSjc = this.maxEndDay
                    }
                    console.log("maxday3 === " + JSON.stringify(util.formatTime(new Date(newSjc), 20)) )
                    return util.formatTime(new Date(this.maxEndDay), 20)  //先使用车场最多日期
                }
            } else {
            // console.log("maxday3 ===  2100/01/01 00:00"   )
                return '2100/01/01 00:00'
            }
        },
        datetimeType() {
        if (this.parkingMess.monthType == 2) {
            return 'date'
        } else {
            return 'month'
        }
        },
        buttoncanClick() {
            if(this.canClick ==false){
                return false
            }
            for(var i=0;i<this.prkParkLotBeanList.length;i++){
                var item = this.prkParkLotBeanList[i];
                if(!item.userName){
                    return false
                }
                if(!item.phone){
                    return false
                }
                if(item.phone.length>11){
                     return false
                }
                if(!item.applyStartDay){
                    return false
                }
                if(!item.applyEndDay){
                    return false
                }
                var pList = item.cardList;
                for(var j=0;j<pList.length;j++){
                    var pItem = pList[j];
                    if(!pItem.cardNumber){
                        return false
                    }
                   if(this.mustImg != 2) {
                       if(pItem.fileList.length <= 0){
                           return false
                       }
                   }

                }
               


            }
            
            return true
        },
        isShowAgreeActon(){
            // if(!this.showXuqianTips && !this.applyMess && !this.repeatApply){
            if(this.isShowAgree){
                return true;
            }

            // }
            return false;
        },
    },
    created(){
        if (Object.keys(this.$store.state.common.userTenantInfo).length > 0) {
            this.isUser = true
        }
        var str =   storage.getS("addPass_parkingMess");
        // console.log('addPass_parkingMess == ' + str )
        if(str){
            this.parkingMess = JSON.parse(str)
            var showAgree =this.parkingMess.enableMonthNotice;
            if(showAgree !=2){
                this.isShowAgree =true
            }else{
                this.isShowAgree =false;
            }
            if (this.parkingMess.prkParkFeeBeanList) {
                var list1 = [];
                for (var i = 0; i < this.parkingMess.prkParkFeeBeanList.length; i++) {
                    var item = this.parkingMess.prkParkFeeBeanList[i];
                    if (item.parkType == 4) {
                        list1.push(item);
                        if (item.companyDiscount < 100) {
                            this.hasDiscount = true;
                        }
                    }
                }
                this.allPrkParkFeeBeanList = list1;
                var num = 3;
                var list = [];
                if (list1.length < 3) {
                    num = list1.length;
                }
                for (var j = 0; j < num; j++) {
                    list.push(list1[j]);
                     
                }
                this.lprkParkFeeBeanList = list;
                this.dayNightType = this.lprkParkFeeBeanList[0].dayNightType;//设置默认选中套餐
                this.ParkFeeId =    this.lprkParkFeeBeanList[0].id;
                this.maxEndDay = this.lprkParkFeeBeanList[0].maxEndDay;
                this.feeTypeName = this.lprkParkFeeBeanList[0].parkTypeName;
                this.vipTypeCode = this.lprkParkFeeBeanList[0].typeCode;
                this.vipTypeName = this.lprkParkFeeBeanList[0].typeName;
            } else {
                this.dayNightType = '';//
                this.ParkFeeId =    '';
                this.maxEndDay='';
                this.feeTypeName = '';
                this.vipTypeCode = '';
                this.vipTypeName ='';
                this.allPrkParkFeeBeanList = [];
                this.lprkParkFeeBeanList = [];
            }
            this.mustImg = this.parkingMess.mustImg
        }else{
             this.dayNightType = '';//
             this.ParkFeeId =    '';
             this.maxEndDay='';
             this.feeTypeName = '';
             this.vipTypeCode = '';
             this.vipTypeName ='';
             this.allPrkParkFeeBeanList = [];
             this.lprkParkFeeBeanList = [];
        }

       
    },
    activated() {
        // if (storage.getS("isNeedFresh")) {
        //     storage.removeS('isNeedFresh')
        //     this.ParkFeeSelectItem = {};
        //     this.getParkId()
        // }

        if (storage.getS("ParkFeeSelectItem")) {
            this.ParkFeeSelectItem = JSON.parse(storage.getS("ParkFeeSelectItem"));
            storage.removeS('ParkFeeSelectItem');
             var tempItem = this.lprkParkFeeBeanList[0];
            for (var i = 0; i < this.lprkParkFeeBeanList.length; i++) { //原数组已经存在选项
                var item = this.lprkParkFeeBeanList[i];
                if (this.ParkFeeSelectItem.id == item.id) {
                    this.lprkParkFeeBeanList[i] = tempItem;
                }
            }
            // this.getMyDiscountParkLot()
            this.lprkParkFeeBeanList[0] = this.ParkFeeSelectItem;
            this.select(this.ParkFeeSelectItem);
        }
    },
    methods:{
        nameInputFun(index) {
            // this.$emit('inputChange', { val: this.userName, type: 'name' })
            console.log(this.prkParkLotBeanList[index])
        },

        sureCardNumber(val) {
            this.showPopup = false;
            var list = this.prkParkLotBeanList[this.selectPass].cardList
            list[this.selectCardIndex].cardNumber = val
            // this.$emit("inputChange", { data: this.cardList, type: 'card' })
        },
         showKeyBoard(selectCardIndex,selectPass) {
            if (this.come == 'xuqian') { return false; }
            this.selectPass = selectPass
             var list = this.prkParkLotBeanList[selectPass].cardList
            this.cardNumber =list[selectCardIndex].cardNumber ||'';
            this.passIndex =selectCardIndex;
            
            this.selectCardIndex = selectCardIndex;//判断是点击哪个车牌
            console.log(this.cardNumber +'----' + this.passIndex +'----'+ this.selectCardIndex) 
            this.showPopup = true;
            
        },
         uploadImgEnd(val) {
            let data = val.data;
            let index = val.index;
            var selectPass =parseInt(index/10000) 
            var selectCardIndex = parseInt(index%10000)
            var list = this.prkParkLotBeanList[selectPass].cardList
            list.forEach((item, i) => {
                if (i == selectCardIndex) {
                    item.fileList.push({ path: data.url, id: data.id })
                }
            })
            // this.$emit("inputChange", { data: this.cardList, type: 'card' })
         },
         resetSign() {
        // 公钥+私钥+时间戳+平台
            let gong = 'vanke2019spaceup009'
            let si = '009vanke2019spaceup001'
            this.timemap = new Date().getTime()
            let platfrom = 'SaasMobile'
            let str = gong + si + this.timemap + platfrom
            this.hex_md5_return = this.$md5(str)
        },

        deleteFile(item, cardIndex, index ,selectPass) {
            let self = this;
            this.resetSign();
            util.showLoading('处理中...')
            fetch(self.removeSomeUrl, {
                method: 'post',
                headers: {
                    'Content-Type': 'application/json',
                    "Access-channel": "saas_rst",
                    "companyId": this.$store.state.common.marketInfo.cityId
                },
                body: JSON.stringify({
                    'ids': item.id,
                    'platform': 'SaasMobile',
                    'timestamp': self.timemap,
                    'sign': self.hex_md5_return,
                    'companyId': this.$store.state.common.marketInfo.cityId
                })
                }).then(response => response.json()).then(res => {
                    console.log(res)
                    util.hideLoading()
                    var list = this.prkParkLotBeanList[selectPass].cardList
                    list[cardIndex].fileList.splice(index, 1)
                })
        },
        addCardNumber(index) {
             var list = this.prkParkLotBeanList[index].cardList
             list.push(
                {
                fileList: [],
                targetId: new Date().getTime(),
                cardNumber: ''
                }
            )
        },
        delectCardItem(cardindex,index) {
            var list = this.prkParkLotBeanList[index].cardList
            list.splice(cardindex, 1)
        },
        dateChange(val) {
            if (this.userS == false) {
                return 
            }
            if (this.timeT == '1') {
                // this.startTime = val
                for(var i=0;i<this.prkParkLotBeanList.length;i++){
                    if(i==this.timeIndex){
                        this.prkParkLotBeanList[i].applyStartDay = val
                    }

                }
            } else {
                // this.endTime = val
                for(var i=0;i<this.prkParkLotBeanList.length;i++){
                    if(i==this.timeIndex){
                        this.prkParkLotBeanList[i].applyEndDay = val
                    }

                }
            }
            this.userS = false;
            
             var that = this
            setTimeout(() => {
               that.date =''
               that.date_m =''
            }, 500);
            
            // this.$emit('inputChange', { val: { startTime: this.startTime, endTime: this.endTime }, type: 'time' })
        },
        selectTime(val,index) {
            this.timeT = val;
            this.timeIndex = index;
            
            if (this.parkingMess.monthType == 2) {
                this.$refs.datetime_date.open();
            }else {
                this.$refs.datetime_month.open();   
            }
            this.userS = true;
           
            // this.userS = true;
        },
       
        toallList() {
           
            storage.setS("FeeListparkingMess", JSON.stringify(this.parkingMess))
            storage.setS("allPrkParkFeeBeanList", JSON.stringify(this.allPrkParkFeeBeanList))
           
            this.$router.push({
                path: "/parkFeeList?dayNightType=" + this.dayNightType + "&isUser=" + this.isUser + "&ParkFeeId=" + this.ParkFeeId
            });
        },
        select(item) {
            if (item) {
                console.log(JSON.stringify(item))
                this.dayNightType = item.dayNightType
                this.ParkFeeId = item.id;
                this.maxEndDay = item.maxEndDay
                this.feeTypeName = item.parkTypeName;
                this.vipTypeCode = item.typeCode;
                this.vipTypeName = item.typeName;
            }
        },

        changeTarget() {
          
            let self = this;
            this.resetSign()
            var list = this.prkParkLotBeanList
            var paramsList = []
            for(var i=0;i<list.length;i++){
                var item = list[i]
                for(var j=0;j<item.cardList.length;j++){
                    var cardItem = item.cardList[j]
                    if(cardItem.fileList.length>0){
                        var obj = {
                            'newTarget':  cardItem.id,
                            'oldTarget': cardItem.targetId,
                            'bizCode': 'TCP',
                            'platform': 'SaasMobile',
                            'timestamp': self.timemap,
                            'sign': self.hex_md5_return,
                            'companyId': self.common.marketInfo.cityId

                        }
                        paramsList.push(obj)
                    }
                }
            }
            console.log('paramsList === ' +  JSON.stringify(paramsList))
            
            fetch(self.changeTargetIdUrl, {
                method: 'post',
                headers: {
                'Content-Type': 'application/json',
                "Access-channel": "saas_rst",
                "companyId": self.common.marketInfo.cityId
                },
                body: JSON.stringify(paramsList)
            }).then(response => response.json()).then(res => {
                console.log("替换成功")
                console.log(res)
            })
        },

         // 验证重复元素，有重复返回true；否则返回false
        isRepeat(arr) {
        var hash = {};
            for (var i in arr) {
                if (hash[arr[i]]) {
                return true;
                }
                // 不存在该元素，则赋值为true，可以赋任意值，相应的修改if判断条件即可
                hash[arr[i]] = true;
            }
            return false;
        },
        validateParams() {
            // 车牌重复校验
            let plateNo = []
            var phone=[]
            for(var i=0;i<this.prkParkLotBeanList.length;i++){
                console.log(i , '  qqqqqqq')
                var item = this.prkParkLotBeanList[i]
                // if(i==0){
                //     phone = item.phone
                // }else{
                //     if(phone == item.phone){
                //          util.showToast('手机号重复！')
                //          return false;
                //     }
                // }
                if(item.phone.length !=11){
                    util.showToast('请输入正确的手机号！')
                    return false;
                }
                phone.push(item.phone)
                var isRepeatPhone = this.isRepeat(phone)
                if (isRepeatPhone) {
                    util.showToast('手机号重复！')
                    return false;
                }
               
                item.cardList.forEach(item => {
                    plateNo.push(item.cardNumber) 
                })
                let isRepeat = this.isRepeat(plateNo)
                if (isRepeat) {
                    util.showToast('车牌号重复！')
                    return false;
                }
                 console.log(i , '  wwwwww')
                // 时间校验
                if(this.parkingMess.monthType == 2 && this.parkingMess.applyMaxUnit == 1){
                    if (new Date(item.applyStartDay.replace(/-/g, "/") + ' 00:00:00').getTime() - new Date(item.applyEndDay.replace(/-/g, "/") + ' 23:59:59').getTime() > 0) {
                        util.showToast('结束时间应该大于开始时间', 2000)
                        return false;
                    }
                    console.log(i , '  aaaaaa')
                }else{   //月租模式 返回日期缺少天
                    if (new Date(item.applyStartDay.replace(/-/g, "/") + '/1 00:00:00').getTime() - new Date(item.applyEndDay.replace(/-/g, "/") + '/1 23:59:59').getTime() > 0) {
                        util.showToast('结束时间应该大于开始时间', 2000)
                        return false;
                    }
                    var ns = item.applyStartDay.replace(/-/g, "/") + '/1 00:00:00';
                    console.log(ns)
     
                    var stime = new Date(item.applyStartDay.replace(/-/g, "/") + '/1 00:00:00')
                    var eTime = new Date(item.applyEndDay.replace(/-/g, "/") + '/1 23:59:59')
                    // console.log("stime1====  " + JSON.stringify(stime1))
                    // console.log("eTime1====  " + JSON.stringify(eTime1))
                    // var stime = new Date(stime1)
                    // var eTime = new Date(eTime1)
                    console.log("stime====  " + JSON.stringify(stime))
                    console.log("eTime====  " + JSON.stringify(eTime))
                    var year1 = util.formatTime(stime, 17).year
                    var month1 = util.formatTime(stime, 17).month
                    var year2 = util.formatTime(eTime, 17).year
                    var month2 = util.formatTime(eTime, 17).month
                    var yc = year2 -year1
                    var mc = month2- month1;
                    var mc1 = yc*12 +mc
                    console.log("yc===" +yc +' year1=== ' + year1 + " year2 ====  " + year2  +'  month1====  ' +month1 + ' month2===== ' + month2 +"mc ==" +mc1)
                    if(mc1>=this.parkingMess.applyMaxCount){
                        util.showToast('注意：结束日期距离设置的开始日期不能超过'+this.parkingMess.applyMaxCount+"个月哦", 2000)
                        return false;
                    }
      

                }
                // 车牌附件校验
                if (this.mustImg == '1') {
                    let status = true;
                    item.cardList.forEach(jItem => {
                        if (jItem.fileList.length == 0) {
                            status = false;
                        }
                    })
                    if (!status) {
                        util.showToast("请上传车牌图片")
                        return false;
                    }
                }
                console.log(i , '  eeeeee')
                // 起租周期
                let applyMinUnit = this.parkingMess.applyMinUnit;//最小起租单位（1天 2月）
                // let applyMaxCount = this.parkingMess.applyMaxCount;//最大起租数
                let applyMinCount = this.parkingMess.applyMinCount;//最小起租数
                // let applyMaxUnit = this.parkingMess.applyMaxUnit;//最大申请单位（1天 2月）
                let monthType = this.parkingMess.monthType;//1(整月模式 年月),2(非整月 年月日)
                if (monthType == 1) {
                    let startD = item.applyStartDay.split("-");
                    let endD = item.applyEndDay.split("-");
                    console.log(i , '  ssssss')
                    if ((endD[0] - startD[0]) * 12 + Number(endD[1]) - Number(startD[1]) < applyMinCount - 1) {
                        util.showToast(`最小起租${applyMinCount}个月`, 2000)
                        return false;
                    }
                } else {
                 // 最小起租单位为天
                    if (applyMinUnit == 1) {
                    // 结束时间-开始时间 小于 最小起租数
                        console.log(i , '  dddddd')
                        if (Math.round((new Date(item.applyEndDay.replace(/-/g, "/") + ' 23:59:59').getTime() - new Date(item.applyStartDay.replace(/-/g, "/") + ' 00:00:00').getTime()) / (24 * 60 * 60 * 1000)) < applyMinCount) {
                            util.showToast(`最小起租${applyMinCount}天`, 2000)
                            return false;
                        }
                    } else {
                    // 开始时间+n月后的时间-结束时间 大于 结束时间
                        console.log(i , '  fffffffff')
                        let startD = item.applyStartDay.split("-");
                        let ys = parseInt((startD[1] - 0 + this.parkingMess.applyMinCount) / 12);
                        let year = startD[0] + ys;
                        let month = startD[1] - 0 + this.parkingMess.applyMinCount - ys * 12 >= 10 ? startD[1] - 0 + this.parkingMess.applyMinCount - ys * 12 : '0' + (startD[1] - 0 + this.parkingMess.applyMinCount - ys * 12)
                        let day = Number(startD[2]) >= 10 ? startD[2] : '0' + startD[2]
                        let newSjc = new Date(year + '/' + month + '/' + day + ' 00:00:00').getTime() - 24 * 60 * 60 * 1000
                        if (newSjc > new Date(item.applyEndDay.replace(/-/g, ".") + ' 23:59:59').getTime()) {
                            util.showToast(`最小起租${applyMinCount}月`, 2000)
                            return false;
                        }
                    }
                }


            }
                
             
                
                
            


            return true
            
        },
        btnClick() {
            // 数据校验
            if(this.validateParams()==false){
                return false
            }
           
            // if (this.applyStartDay.split('-').length === 2) {
            //     this.applyStartDay = this.applyStartDay + "-01"
            //     let endt = new Date(this.applyEndDay.split('-')[0], this.applyEndDay.split('-')[1], 0);
            //     let { year, month, day } = util.formatTime(endt, 17);
            //     this.applyEndDay = util.formatTime(new Date(year + '/' + month + '/' + day + ' 23:59:59'), 9)
            // }
            var list = [];
            // console.log(JSON.stringify(this.prkParkLotBeanList))    
            for(var i = 0; i < this.prkParkLotBeanList.length; i++){
                var jItem = this.prkParkLotBeanList[i]
                //  this.dayNightType = item.dayNightType
                var pList =[]
                for(var j = 0; j < jItem.cardList.length; j++){
                    pList.push(jItem.cardList[j].cardNumber)
                }
                var item ={
                    platform:"RST",
                    userId:this.common.userId,
                    userName:jItem.userName,
                    companyName:this.common.userTenantInfo.company,
                    companyId:this.common.userTenantInfo.companyId,
                    subProjectId:this.common.marketInfo.id,//项目id,
                    phone:jItem.phone,
                    numberType:2,
                    parkHeaderId:this.parkingMess.id,//车场id,
                    plateNo:pList.join(','),
                    applyStartDay:jItem.applyStartDay.replace(/-/g, ".") + ' 00:00:00',
                    applyEndDay:jItem.applyEndDay.replace(/-/g, ".") + ' 23:59:59',
                    dayNightType:this.dayNightType,
                    feeTypeId: this.ParkFeeId,
                    feeTypeName: this.feeTypeName,

                }
                list.push(item)

            }
      
            util.showLoading('提交中...')
            this.canClick = false
            // 
            let params = {
                prkParkLotBeanList:list,
                "url": "/parking/rstParkLot/applayCompanyParkLot"
            }
          
            loadParkHeaderById(params).then(res => {
                console.log(JSON.stringify(res)) 
                if (res.res.code === 10000 && res.body) {
                    let list = res.body.data.prkParkLotBeanList || [];
                    res.body.data.applyStatus = list[0].applyStatus
                    for(var i = 0; i < this.prkParkLotBeanList.length; i++){
                        var item = this.prkParkLotBeanList[i]
                        var jItem = list[i]
                        if(jItem){
                            for(var j = 0; j < item.cardList.length; j++){
                                item.cardList[j].id = jItem.prkParkLotPlateBeans[j].id
                            }
                        }

                    }
                    // console.log( 'approvalProcess  '  +  JSON.stringify(this.prkParkLotBeanList))
                    this.changeTarget()
               
                // 如果剩余车位没有了,不发起审批
                   
                    if (this.parkingMess.overplusPMonthlyNumber <= 0) {
                        util.hideLoading()
                        this.canClick = true
                        this.backAction()
                    
                    } else {
                        // 发起审批申请待办
                        if(res.body.data.applyStatus ==1){
                            console.log( 'in approvalProcess  action ')
                            this.approvalProcess(res.body.data,
                                () => {
                                    util.hideLoading()
                                    this.backAction()
                                    // this.loadParkLot()
                                }, () => {
                                    this.canClick = true
                                    util.hideLoading()
                                    util.showToast('提交失败')
                            })
                        
                        }else{
                            this.canClick = true
                            util.hideLoading()
                            this.backAction()
                        }
                    }
                } else {
                    this.canClick = true
                    util.hideLoading()
                    util.showToast(res.res.msg)
                }
            })
        },

        backAction(){
            this.$router.go(-1)
        },


        addCard(){
            var obj = {
                platform:"RST",
                userId:"",
                
                companyName:"",
                companyId:"",
                subProjectId:"2",
                
                numberType:2,
                parkHeaderId:'',
                plateNo:"",
                cardList:[{
                     fileList: [],
                     targetId: new Date().getTime(),
                     cardNumber: ''
                }],
                phone:"",
                userName:"",
                applyStartDay:"",
                applyEndDay:"",
                dayNightType:''
            }
            this.prkParkLotBeanList.push(obj)
        },

        deleteCard(index){
            this.prkParkLotBeanList.splice(index,1)
        },

       

        changeDayNightType(item){
            this.dayNightType = item.value

        },

        addAction(){

        },
         changeAgree(){
                this.isAgree =!this.isAgree;
                // if (!this.userName || !this.applyStartDay || !this.applyEndDay || !this.plateNo ||!this.isAgree) {
                //     this.canClick = false
                // } else {
                //     this.canClick = true
                // }
        },
        showAgreePopup(){
            this.isshowPopup=true;
        },
        hidePopup(){
            this.isshowPopup =false;
        },
    },

}

</script>

<style lang="less" scoped>
@import "../../assets/css/common.less";
.parking_box {
  background: #eee;
}

.package_top {
  flex-direction: row;
  display: flex;
  // margin-top: 28px;
  width: 100%;
  // height: 70px;
  background-color: #ffffff;
  padding-top: 28px;
  justify-content: space-between;
  // background-color: red;
}
.package_top_left {
  flex-direction: row;
  margin-left: 28px;
}
.package_top_span {
  height: 42px;
  font-size: 30px;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
  line-height: 42px;
}
.package_top_right {
  flex-direction: row;
  margin-right: 28px;
}
.package_top_span1 {
  height: 42px;
  font-size: 30px;
  font-weight: 400;
  color: rgba(201, 201, 201, 1);
  line-height: 42px;
}
.package_top_icon {
  margin-top: -4px;
  margin-left: 4px;
  width: 32px;
  height: 32px;
}
.package_box {
  background: #fff;
  padding: 28px 13px;
  .flex();
  .package_item {
    flex: 1;
    flex-shrink: 0;
    margin: 0 7px;
    padding-left: 16px;
    // height:176px;
    border-radius: 8px;
    border: 4px solid rgba(239, 239, 239, 1);
    box-sizing: border-box;
    position: relative;
    background: rgba(248, 248, 248, 1);
    .discount {
      position: relative;
      left: -20px;
      top: -4px;
      width: 132px;
      height: 40px;
    }
    .img_h {
      height: 40px;
    }
    .underline_text {
      text-decoration: line-through;
      font-size: 24px;
      color: #999;
      margin-bottom: 20px;
    }
    .h3div {
      width: 140px;
      display: flex;
      .h3Span {
        font-size: 28px;
        font-weight: bold;
        color: rgba(51, 51, 51, 1);
        line-height: 34px;
        //   height: 80px;
        width: 140px;
        margin-top: 16px;
        margin-bottom: 10px;
        // white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        lines: 2;
        max-lines: 2;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
      }
    }
    .time_range {
      white-space: nowrap;
      height: 32px;
      font-size: 24px;
      color: rgba(102, 102, 102, 1);
      line-height: 32px;
      margin-bottom: 14px;
      span {
        font-size: 20px;
        color: #16bc84;
      }
    }
    .price_box {
      .flex();
      align-items: flex-end;
      margin-bottom: 12px;
      p {
        font-size: 44px;
        color: rgba(252, 63, 86, 1);
        margin-right: 4px;
      }
      span {
        font-size: 26px;
        color: rgba(51, 51, 51, 1);
        line-height: 36px;
      }
    }
    .icon_t {
      position: absolute;
      top: 20px;
      right: 24px;
      width: 28px;
      height: 28px;
    }
    .icon_select {
      position: absolute;
      bottom: -2px;
      right: -3px;
      width: 36px;
      height: 36px;
      display: none;
    }
  }
  .cur {
    background: rgba(246, 248, 254, 1);
    border: 4px solid rgba(23, 64, 218, 1);
    .icon_select {
      display: block;
    }
  }
  .package_item_one {
    width: 348px;
    flex: 0 1 auto;
  }
}
.identity {
  display: block;
  padding: 0 20px 28px 20px;
  width: 100%;
  height: auto;
  box-sizing: border-box;
  background: #fff;
}
.card_box {
  background: #fff;
  padding: 0 0px;
  position: relative;
  .delect_icon {
    width: 44px;
    height: 44px;
    position: absolute;
    top: 28px;
    right: 28px;
    z-index: 2;
  }
}

.apply_mess {
  margin-bottom: 14px;
  h3 {
    font-size: 30px;
    color: rgba(153, 153, 153, 1);
    line-height: 42px;
    padding: 28px 0 20px 28px;
  }
  .mess_list {
    background: #fff;
    position: relative;
    .mess_list_item {
      padding: 0 28px;
      position: relative;
      .flex();
      height: 100px;
      align-items: center;
      .list_item_left {
        width: 164px;
        font-size: 30px;
        color: rgba(51, 51, 51, 1);
        span {
          color: #fc3f56;
        }
      }
      .list_item_right {
        flex: 1;
        height: 100px;
        .borderB();
        font-size: 30px;
        color: #333;
        box-sizing: border-box;
      }
      .list_item_right_p {
        line-height: 100px;
      }
      .list_item_right_card{
          flex: 1;
        height: 100px;
        .borderB();
        font-size: 30px;
        line-height: 100px;
        color: #333;
        box-sizing: border-box;

      }
      .last {
        .borderB(#fff);
      }
      .placeholder {
        color: #c9c9c9;
      }
      .notclick {
        opacity: 0.6;
      }
      img {
        display: block;
        position: absolute;
        right: 28px;
        top: 34px;
        width: 32px;
        height: 32px;
      }
    }
    .delect_icon {
        width: 44px;
        height: 44px;
        position: absolute;
        top: 28px;
        right: 28px;
        z-index: 2;
    }
  }
   h4 {
    font-size: 30px;
    color: rgba(51, 51, 51, 1);
    line-height: 42px;
    margin: 00px 0 00px;
    padding-left: 28px;
    padding-top:28px;

    span {
      color: #fc3f56;
    }
  }
  .tips {
    background-color: #fff;
    font-size: 26px;
    padding-left: 28px;
    padding-top:28px;
    color: rgba(153, 153, 153, 1);
    line-height: 36px;
    padding-bottom: 28px;
    span {
      margin-bottom: 10px;
      display: flex;
    }
  }
}
.end_time {
  .flex();
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-top: 200px;
  img {
    display: block;
    width: 108px;
    height: 108px;
    margin-bottom: 44px;
  }
  p {
    text-align: center;
    font-size: 30px;
    color: rgba(153, 153, 153, 1);
    line-height: 42px;
  }
}

.pic {
    background-color: #fff;
     padding-left: 28px;
    padding-top:16px;
  display: flex;
  flex-wrap: wrap;
  position: relative;
  .addPic {
    width: 160px;
    height: 160px;
    background: rgba(244, 244, 244, 1);
    border-radius: 8px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    position: relative;
    margin-bottom: 28px;
    margin-right: 28px;
    .video_icon {
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      width: 68px;
      height: 68px;
    }
    .video {
      width: 160px;
      height: 160px;
    }
    .addImg {
      width: 28px;
      height: 28px;
    }
    .item_center_inp {
      position: absolute;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
    }
    .file {
      position: absolute;
      width: 160px;
      height: 160px;
      opacity: 0;
    }
    .deleteFile {
      position: absolute;
      right: -25px;
      top: -25px;
      width: 50px;
      height: 50px;
    }
  }
}
// 添加车牌
.add_card {
  .flex();
  background-color: #ffffff;
  justify-content: flex-end;
  padding: 6px 20px 20px 0;
  .add_card_main {
    width: 200px;
    height: 68px;
    border-radius: 34px;
    background: #0087ff;
    .flex();
    justify-content: center;
    align-items: center;
    img {
      width: 32px;
      height: 32px;
      margin-right: 8px;
    }
    span {
      font-size: 28px;
      color: #fff;
    }
  }
}
.chewei{
    margin-top: 20px;
   background: #eee;
}
.bottom_box{
    width: 100%;
    height: 80px;
    display: flex;
    margin-bottom: 20px;
}




.agreeView{
  position: fixed;
  bottom:108px;left:0;right:0;
  // box-shadow:0px -1px 14px 0px rgba(0,0,0,0.09);
  z-index:333;
  background:#fff;
  height:88px;
  width:100%;
   display: flex;
  flex-direction: row;
  align-items: center;
}
.agreeView_div{
  //  display: flex;
   margin-left: 28px;
   width: 32px;
   height: 32px;
   border-radius: 100%;
   border: 2px solid #eaeaea;
   background-color: white;
}
.agreeView_icon{
   margin-left: 28px;
   width: 36px;
   height: 36px;
}
.agreeView_span1{
  margin-left: 14px;
  height:36px;
  font-size:26px;
  font-weight:400;
  color:rgba(51,51,51,1);
  line-height:36px;
}
.agreeView_span2{
  margin-left: 4px;
  height:36px;
  font-size:26px;
  font-weight:400;
  color:#1740DA;
  line-height:36px;
}
.popupview{
  width:600px;
  display: flex;
  flex-direction: column;
  
  background-color: #fff;
  border-radius:8px;
}
.popupview-span1{
  margin-left: 40px;
  margin-top: 40px;
 
  width: 520px;
  font-size:40px;
  text-align: center;
  font-weight:500;
  color:rgba(51,51,51,1);
  line-height:56px;
}
.popupview-span2{
  margin-left: 40px;
  margin-top: 28px;
  width: 520px;
  height: 450px;
  font-size:28px;
  font-weight:400;
  color:rgba(51,51,51,1);
  line-height:40px;
}
.popupview-span3{
  margin-left: 40px;
  margin-top: 62px;
  margin-bottom: 40px;
  
  width:520px;
  height:88px;
  background:rgba(23,64,218,1);
  border-radius:4px;
  text-align: center;
  font-size:34px;
  font-weight:400;
  color:rgba(255,255,255,1);
  line-height:88px;


}


</style>